// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_search.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AccessReviewSearchService } from "./accessreview_search";
import type { SearchAppRollupResponse } from "./accessreview_search";
import type { SearchAppRollupRequest } from "./accessreview_search";
import type { SearchAppUserRollupResponse } from "./accessreview_search";
import type { SearchAppUserRollupRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceNavNextSelectionResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceNavNextSelectionRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceNavFirstOpenSelectionResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceNavFirstOpenSelectionRequest } from "./accessreview_search";
import type { AccessReviewAppUserRollupNavDataResponse } from "./accessreview_search";
import type { AccessReviewAppUserRollupNavDataRequest } from "./accessreview_search";
import type { AccessReviewAppUserDetailRowSearchResponse } from "./accessreview_search";
import type { AccessReviewAppUserDetailRowSearchRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceSearchSelectedResourceRollupResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceSearchSelectedResourceRollupRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceSearchEntitlementsCountResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceSearchEntitlementsCountRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceSearchEntitlementsResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceSearchEntitlementsRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceUserRollupUserNavDataResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceUserRollupUserNavDataRequest } from "./accessreview_search";
import type { AccessReviewAccountsWithNoIdentityTaskStatus } from "./accessreview_search";
import type { AccountsWithNoIdentityTaskStatusRequest } from "./accessreview_search";
import type { AccessReviewAccountsWithNoIdentityTaskCounts } from "./accessreview_search";
import type { AccountsWithNoIdentityTaskCountsRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceUserRollupResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceUserRollupRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceEntitlementRollupByAppResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceEntitlementRollupByAppRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceEntitlementRollupResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceEntitlementRollupRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceRollupResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceRollupRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceGetReviewerDecisionsResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceGetReviewerDecisionsRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceCountIncompleteReviewersResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceCountIncompleteReviewersRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceCountCompleteReviewersResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceCountCompleteReviewersRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceGetProgressByAppResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceGetProgressByAppRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceCountOpenReviewsByUserResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceCountOpenReviewsByUserRequest } from "./accessreview_search";
import type { AccessReviewSearchServiceSelectionsStatusResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceSelectionsStatusRequest } from "./accessreview_search";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { AccessReviewSearchServiceSearchResponse } from "./accessreview_search";
import type { AccessReviewSearchServiceSearchRequest } from "./accessreview_search";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewSearchService
 */
export interface IAccessReviewSearchServiceClient {
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: AccessReviewSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchRequest, AccessReviewSearchServiceSearchResponse>;
    /**
     * @generated from protobuf rpc: SelectionsStatus
     */
    selectionsStatus(input: AccessReviewSearchServiceSelectionsStatusRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSelectionsStatusRequest, AccessReviewSearchServiceSelectionsStatusResponse>;
    /**
     * @generated from protobuf rpc: CountOpenReviewsByUser
     */
    countOpenReviewsByUser(input: AccessReviewSearchServiceCountOpenReviewsByUserRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceCountOpenReviewsByUserRequest, AccessReviewSearchServiceCountOpenReviewsByUserResponse>;
    /**
     * @generated from protobuf rpc: GetProgressByApp
     */
    getProgressByApp(input: AccessReviewSearchServiceGetProgressByAppRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceGetProgressByAppRequest, AccessReviewSearchServiceGetProgressByAppResponse>;
    /**
     * @generated from protobuf rpc: CountCompleteReviewers
     */
    countCompleteReviewers(input: AccessReviewSearchServiceCountCompleteReviewersRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceCountCompleteReviewersRequest, AccessReviewSearchServiceCountCompleteReviewersResponse>;
    /**
     * @generated from protobuf rpc: CountIncompleteReviewers
     */
    countIncompleteReviewers(input: AccessReviewSearchServiceCountIncompleteReviewersRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceCountIncompleteReviewersRequest, AccessReviewSearchServiceCountIncompleteReviewersResponse>;
    /**
     * @generated from protobuf rpc: GetReviewerDecisions
     */
    getReviewerDecisions(input: AccessReviewSearchServiceGetReviewerDecisionsRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceGetReviewerDecisionsRequest, AccessReviewSearchServiceGetReviewerDecisionsResponse>;
    /**
     * @generated from protobuf rpc: Rollup
     */
    rollup(input: AccessReviewSearchServiceRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceRollupRequest, AccessReviewSearchServiceRollupResponse>;
    /**
     * @generated from protobuf rpc: EntitlementRollup
     */
    entitlementRollup(input: AccessReviewSearchServiceEntitlementRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceEntitlementRollupRequest, AccessReviewSearchServiceEntitlementRollupResponse>;
    /**
     * @generated from protobuf rpc: EntitlementRollupByApp
     */
    entitlementRollupByApp(input: AccessReviewSearchServiceEntitlementRollupByAppRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceEntitlementRollupByAppRequest, AccessReviewSearchServiceEntitlementRollupByAppResponse>;
    /**
     * @generated from protobuf rpc: UserRollup
     */
    userRollup(input: AccessReviewSearchServiceUserRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceUserRollupRequest, AccessReviewSearchServiceUserRollupResponse>;
    /**
     * @generated from protobuf rpc: AccountsWithNoIdentityTaskCount
     */
    accountsWithNoIdentityTaskCount(input: AccountsWithNoIdentityTaskCountsRequest, options?: RpcOptions): UnaryCall<AccountsWithNoIdentityTaskCountsRequest, AccessReviewAccountsWithNoIdentityTaskCounts>;
    /**
     * @generated from protobuf rpc: AccountsWithNoIdentityTaskStatus
     */
    accountsWithNoIdentityTaskStatus(input: AccountsWithNoIdentityTaskStatusRequest, options?: RpcOptions): UnaryCall<AccountsWithNoIdentityTaskStatusRequest, AccessReviewAccountsWithNoIdentityTaskStatus>;
    /**
     * @generated from protobuf rpc: UserRollupNavData
     */
    userRollupNavData(input: AccessReviewSearchServiceUserRollupUserNavDataRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceUserRollupUserNavDataRequest, AccessReviewSearchServiceUserRollupUserNavDataResponse>;
    /**
     * @generated from protobuf rpc: SearchEntitlements
     */
    searchEntitlements(input: AccessReviewSearchServiceSearchEntitlementsRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchEntitlementsRequest, AccessReviewSearchServiceSearchEntitlementsResponse>;
    /**
     * @generated from protobuf rpc: SearchEntitlementsCount
     */
    searchEntitlementsCount(input: AccessReviewSearchServiceSearchEntitlementsCountRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchEntitlementsCountRequest, AccessReviewSearchServiceSearchEntitlementsCountResponse>;
    /**
     * @generated from protobuf rpc: SearchSelectedResourceRollup
     */
    searchSelectedResourceRollup(input: AccessReviewSearchServiceSearchSelectedResourceRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchSelectedResourceRollupRequest, AccessReviewSearchServiceSearchSelectedResourceRollupResponse>;
    /**
     * @generated from protobuf rpc: SearchSelectedResourceTypeRollup
     */
    searchSelectedResourceTypeRollup(input: AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest, AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse>;
    /**
     * @generated from protobuf rpc: AppUserDetailRowRollup
     */
    appUserDetailRowRollup(input: AccessReviewAppUserDetailRowSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewAppUserDetailRowSearchRequest, AccessReviewAppUserDetailRowSearchResponse>;
    /**
     * @generated from protobuf rpc: AppUserDetailRowRollupNavData
     */
    appUserDetailRowRollupNavData(input: AccessReviewAppUserRollupNavDataRequest, options?: RpcOptions): UnaryCall<AccessReviewAppUserRollupNavDataRequest, AccessReviewAppUserRollupNavDataResponse>;
    /**
     * @generated from protobuf rpc: NavFirstOpenSelection
     */
    navFirstOpenSelection(input: AccessReviewSearchServiceNavFirstOpenSelectionRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceNavFirstOpenSelectionRequest, AccessReviewSearchServiceNavFirstOpenSelectionResponse>;
    /**
     * @generated from protobuf rpc: NavNextSelection
     */
    navNextSelection(input: AccessReviewSearchServiceNavNextSelectionRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceNavNextSelectionRequest, AccessReviewSearchServiceNavNextSelectionResponse>;
    /**
     * @generated from protobuf rpc: SearchAppUserRollup
     */
    searchAppUserRollup(input: SearchAppUserRollupRequest, options?: RpcOptions): UnaryCall<SearchAppUserRollupRequest, SearchAppUserRollupResponse>;
    /**
     * @generated from protobuf rpc: SearchAppRollup
     */
    searchAppRollup(input: SearchAppRollupRequest, options?: RpcOptions): UnaryCall<SearchAppRollupRequest, SearchAppRollupResponse>;
}
/**
 * @generated from protobuf service c1.api.accessreview.v1.AccessReviewSearchService
 */
export class AccessReviewSearchServiceClient implements IAccessReviewSearchServiceClient, ServiceInfo {
    typeName = AccessReviewSearchService.typeName;
    methods = AccessReviewSearchService.methods;
    options = AccessReviewSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: AccessReviewSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchRequest, AccessReviewSearchServiceSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceSearchRequest, AccessReviewSearchServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SelectionsStatus
     */
    selectionsStatus(input: AccessReviewSearchServiceSelectionsStatusRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSelectionsStatusRequest, AccessReviewSearchServiceSelectionsStatusResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceSelectionsStatusRequest, AccessReviewSearchServiceSelectionsStatusResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountOpenReviewsByUser
     */
    countOpenReviewsByUser(input: AccessReviewSearchServiceCountOpenReviewsByUserRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceCountOpenReviewsByUserRequest, AccessReviewSearchServiceCountOpenReviewsByUserResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceCountOpenReviewsByUserRequest, AccessReviewSearchServiceCountOpenReviewsByUserResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetProgressByApp
     */
    getProgressByApp(input: AccessReviewSearchServiceGetProgressByAppRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceGetProgressByAppRequest, AccessReviewSearchServiceGetProgressByAppResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceGetProgressByAppRequest, AccessReviewSearchServiceGetProgressByAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountCompleteReviewers
     */
    countCompleteReviewers(input: AccessReviewSearchServiceCountCompleteReviewersRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceCountCompleteReviewersRequest, AccessReviewSearchServiceCountCompleteReviewersResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceCountCompleteReviewersRequest, AccessReviewSearchServiceCountCompleteReviewersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountIncompleteReviewers
     */
    countIncompleteReviewers(input: AccessReviewSearchServiceCountIncompleteReviewersRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceCountIncompleteReviewersRequest, AccessReviewSearchServiceCountIncompleteReviewersResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceCountIncompleteReviewersRequest, AccessReviewSearchServiceCountIncompleteReviewersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetReviewerDecisions
     */
    getReviewerDecisions(input: AccessReviewSearchServiceGetReviewerDecisionsRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceGetReviewerDecisionsRequest, AccessReviewSearchServiceGetReviewerDecisionsResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceGetReviewerDecisionsRequest, AccessReviewSearchServiceGetReviewerDecisionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Rollup
     */
    rollup(input: AccessReviewSearchServiceRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceRollupRequest, AccessReviewSearchServiceRollupResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceRollupRequest, AccessReviewSearchServiceRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EntitlementRollup
     */
    entitlementRollup(input: AccessReviewSearchServiceEntitlementRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceEntitlementRollupRequest, AccessReviewSearchServiceEntitlementRollupResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceEntitlementRollupRequest, AccessReviewSearchServiceEntitlementRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: EntitlementRollupByApp
     */
    entitlementRollupByApp(input: AccessReviewSearchServiceEntitlementRollupByAppRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceEntitlementRollupByAppRequest, AccessReviewSearchServiceEntitlementRollupByAppResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceEntitlementRollupByAppRequest, AccessReviewSearchServiceEntitlementRollupByAppResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UserRollup
     */
    userRollup(input: AccessReviewSearchServiceUserRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceUserRollupRequest, AccessReviewSearchServiceUserRollupResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceUserRollupRequest, AccessReviewSearchServiceUserRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AccountsWithNoIdentityTaskCount
     */
    accountsWithNoIdentityTaskCount(input: AccountsWithNoIdentityTaskCountsRequest, options?: RpcOptions): UnaryCall<AccountsWithNoIdentityTaskCountsRequest, AccessReviewAccountsWithNoIdentityTaskCounts> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccountsWithNoIdentityTaskCountsRequest, AccessReviewAccountsWithNoIdentityTaskCounts>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AccountsWithNoIdentityTaskStatus
     */
    accountsWithNoIdentityTaskStatus(input: AccountsWithNoIdentityTaskStatusRequest, options?: RpcOptions): UnaryCall<AccountsWithNoIdentityTaskStatusRequest, AccessReviewAccountsWithNoIdentityTaskStatus> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccountsWithNoIdentityTaskStatusRequest, AccessReviewAccountsWithNoIdentityTaskStatus>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UserRollupNavData
     */
    userRollupNavData(input: AccessReviewSearchServiceUserRollupUserNavDataRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceUserRollupUserNavDataRequest, AccessReviewSearchServiceUserRollupUserNavDataResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceUserRollupUserNavDataRequest, AccessReviewSearchServiceUserRollupUserNavDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchEntitlements
     */
    searchEntitlements(input: AccessReviewSearchServiceSearchEntitlementsRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchEntitlementsRequest, AccessReviewSearchServiceSearchEntitlementsResponse> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceSearchEntitlementsRequest, AccessReviewSearchServiceSearchEntitlementsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchEntitlementsCount
     */
    searchEntitlementsCount(input: AccessReviewSearchServiceSearchEntitlementsCountRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchEntitlementsCountRequest, AccessReviewSearchServiceSearchEntitlementsCountResponse> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceSearchEntitlementsCountRequest, AccessReviewSearchServiceSearchEntitlementsCountResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchSelectedResourceRollup
     */
    searchSelectedResourceRollup(input: AccessReviewSearchServiceSearchSelectedResourceRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchSelectedResourceRollupRequest, AccessReviewSearchServiceSearchSelectedResourceRollupResponse> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceSearchSelectedResourceRollupRequest, AccessReviewSearchServiceSearchSelectedResourceRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchSelectedResourceTypeRollup
     */
    searchSelectedResourceTypeRollup(input: AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest, AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceSearchSelectedResourceTypeRollupRequest, AccessReviewSearchServiceSearchSelectedResourceTypeRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AppUserDetailRowRollup
     */
    appUserDetailRowRollup(input: AccessReviewAppUserDetailRowSearchRequest, options?: RpcOptions): UnaryCall<AccessReviewAppUserDetailRowSearchRequest, AccessReviewAppUserDetailRowSearchResponse> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewAppUserDetailRowSearchRequest, AccessReviewAppUserDetailRowSearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AppUserDetailRowRollupNavData
     */
    appUserDetailRowRollupNavData(input: AccessReviewAppUserRollupNavDataRequest, options?: RpcOptions): UnaryCall<AccessReviewAppUserRollupNavDataRequest, AccessReviewAppUserRollupNavDataResponse> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewAppUserRollupNavDataRequest, AccessReviewAppUserRollupNavDataResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: NavFirstOpenSelection
     */
    navFirstOpenSelection(input: AccessReviewSearchServiceNavFirstOpenSelectionRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceNavFirstOpenSelectionRequest, AccessReviewSearchServiceNavFirstOpenSelectionResponse> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceNavFirstOpenSelectionRequest, AccessReviewSearchServiceNavFirstOpenSelectionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: NavNextSelection
     */
    navNextSelection(input: AccessReviewSearchServiceNavNextSelectionRequest, options?: RpcOptions): UnaryCall<AccessReviewSearchServiceNavNextSelectionRequest, AccessReviewSearchServiceNavNextSelectionResponse> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<AccessReviewSearchServiceNavNextSelectionRequest, AccessReviewSearchServiceNavNextSelectionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppUserRollup
     */
    searchAppUserRollup(input: SearchAppUserRollupRequest, options?: RpcOptions): UnaryCall<SearchAppUserRollupRequest, SearchAppUserRollupResponse> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppUserRollupRequest, SearchAppUserRollupResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchAppRollup
     */
    searchAppRollup(input: SearchAppRollupRequest, options?: RpcOptions): UnaryCall<SearchAppRollupRequest, SearchAppRollupResponse> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppRollupRequest, SearchAppRollupResponse>("unary", this._transport, method, opt, input);
    }
}
